import { ProjectActions } from '@store/actions';
import { distructAndDispatch } from '../../core/utils/methods/destruct-and-dispatch';
import {
  FinancialData,
  PermittingSummaryData,
  ProjectDetailsResponse,
  ProjectPaceTask,
  User,
} from '../../models/interfaces';
import { FinancialActions } from '../actions/financial.actions';

export namespace PermittingEffects {
  export const setPaceTasks = distructAndDispatch<
    PermittingSummaryData,
    ProjectPaceTask[]
  >('paceTasks', ProjectActions.updateProjectPaceTasksAction);

  export const setPaceTaskFields = distructAndDispatch<
    PermittingSummaryData,
    ProjectPaceTask[]
  >('paceTaskFields', ProjectActions.updateProjectPaceTaskFields);

  export const setCurrentProvidenceAgent = distructAndDispatch<
    PermittingSummaryData,
    User
  >('providenceAgent', ProjectActions.setCurrentProvidenceAgent);

  export const setFinancial = distructAndDispatch<
    ProjectDetailsResponse & { financial?: FinancialData | null },
    FinancialData
  >('financial', FinancialActions.getFinancialDataAction);
}
